import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const DATE_RULE_EDITOR_CLASS_NAME = 'DateRuleEditor';
export const DATE_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type DateRuleEditorClassSlot =
	(typeof DATE_RULE_EDITOR_CLASS_SLOTS)[number];

export interface DateRuleEditorClasses {
	root: string;
}

export type DateRuleEditorClassKey = keyof DateRuleEditorClasses;

export const getDateRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(DATE_RULE_EDITOR_CLASS_NAME, slot);

export const dateRuleEditorClasses: DateRuleEditorClasses =
	generateUtilityClasses(DATE_RULE_EDITOR_CLASS_NAME, ['root']);

export default dateRuleEditorClasses;
